// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
// -----------------------
import rawworkorder from './rawworkorder'
import reduxcss from './redux-css'
import common from './common'
import dashboard from './dashboard'
import admin from "./admin"

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  rawworkorder,
  reduxcss,
  common, 
  dashboard,
  admin
})

export default rootReducer


